import React from 'react'
import { Card, Col, Row, Statistic } from 'antd'
import {
  DollarOutlined,
  ShoppingCartOutlined,
  PercentageOutlined,
  TagOutlined,
  RiseOutlined,
  UserOutlined
} from '@ant-design/icons'
import { textNumberFormater } from '../../../utils'

export type TSummaryCard = {
  title: string
  value: number | string
  prefix?: React.ReactNode
  suffix?: string
  color?: string
  format?: 'money' | 'number' | 'percent' | 'text'
}

type ReportSummaryCardsProps = {
  cards: TSummaryCard[]
  loading?: boolean
}

const iconMap: Record<string, React.ReactNode> = {
  dollar: <DollarOutlined />,
  cart: <ShoppingCartOutlined />,
  percent: <PercentageOutlined />,
  tag: <TagOutlined />,
  rise: <RiseOutlined />,
  user: <UserOutlined />
}

function ReportSummaryCards({ cards, loading }: Readonly<ReportSummaryCardsProps>) {
  const getFormattedValue = (card: TSummaryCard) => {
    if (card.format === 'money') {
      return textNumberFormater(card.value as number)
    }
    if (card.format === 'percent') {
      return `${card.value}%`
    }
    return card.value
  }

  // Calcular span según la cantidad de cards
  const getSpan = () => {
    if (cards.length <= 3) return { xs: 24, sm: 12, md: 8 }
    if (cards.length === 4) return { xs: 24, sm: 12, md: 6 }
    if (cards.length === 5) return { xs: 24, sm: 12, md: 8, lg: 4, xl: 4 }
    return { xs: 24, sm: 12, md: 8, lg: 6, xl: 4 }
  }

  const span = getSpan()

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
      {cards.map((card, index) => (
        <Col key={card.title + index} {...span}>
          <Card
            hoverable
            style={{
              borderLeft: `4px solid ${card.color || '#1890ff'}`,
              height: '100%'
            }}
            bodyStyle={{ padding: '16px 20px' }}
          >
            <Statistic
              title={<span style={{ color: '#666', fontSize: 13 }}>{card.title}</span>}
              value={getFormattedValue(card) as string}
              prefix={card.prefix}
              suffix={card.suffix}
              loading={loading}
              valueStyle={{
                color: card.color || '#1890ff',
                fontSize: 22,
                fontWeight: 600
              }}
            />
          </Card>
        </Col>
      ))}
    </Row>
  )
}

export { iconMap }
export default ReportSummaryCards
